<template>
  <div class="notice">
    <h2 class="notice__title">Notice</h2>
    <ol class="notice__list">
      <!-- 上位1つで、中身が空の場合は飛ばす    -->
      <li class="notice__list--item" v-for="item in NoticeListFilters.slice(0, 2)" :key="item.id">
        <router-link
          :to="{
            path: `/${langPath}notice`,
            query: { id: item.id },
          }"
          class="notice-link"
        >
          <div class="notice-detail">
            <time class="notice-date">
              {{ item.time }}
            </time>
          </div>
          <div class="notice-description">
            {{ item.title[lang] }}
          </div>
        </router-link>
      </li>
    </ol>
  </div>
</template>

<script>
import NoticeList from "../../../assets/constants/top/notice-list";
export default {
  data() {
    return {
      NoticeListFilters: [],
    };
  },
  created() {
    this.NoticeListFilters = NoticeList.items
      .filter((item) => item.title[this.lang] !== "")
      .reverse();
  },
  props: {
    lang: {
      type: String,
    },
    langPath: {
      type: String,
    },
  },
  name: "noticeList",
};
</script>

<style scoped>
.notice {
  margin: 60px 0 0 0;
  text-align: center;

  &__title {
    display: inline-block;
    line-height: 1.4;
    text-align: center;
    font-size: 60px;
    &::after {
      content: "";
      display: block;
      height: 10px;
      background: url("../../../assets/images/border/border_results.svg");
      background-size: 101%;
    }
  }

  &__list {
    padding: 0 15px;
    text-align: left;

    &--item {
      padding: 25px 0 20px 0;
      border-bottom: solid 1px var(--defaultBlackColor);

      &:hover {
        background-color: var(--defaultGrayColor);
        transition-duration: 0.3s;
      }

      .notice-detail {
        display: flex;
        font-size: 16px;

        .notice-date {
          font-weight: bold;
        }
      }

      .notice-description {
        margin: 12px 0 0 0;
        font-size: 20px;
        line-height: 1.4;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/top/NoticeList.vue